import React from "react"
import { useExhibitorDataState } from "../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../globalStates/LanguageState"
import { withReferenceDataState } from "../../globalStates/ReferenceDataHOC"
import { ReferenceDataState } from "../../globalStates/ReferenceDataState"
import { useConfigDataState } from "../../globalStates/ConfigDataState"
import Page from "../../components/Page"
import LinksContents from "./LinksContents"

interface LinksPageProps {
    refDataState: ReferenceDataState
}

const LinksPage: React.FC<LinksPageProps> = ({ refDataState }) => {
    const branding = useLanguageState().getStrings()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const linksLimit = serviceKeys.link || 0
    const linksStates = useExhibitorDataState().getLinks()

    return (
        <Page description={branding.configuration.linksPage.pageDescription}>
            <LinksContents linksStates={linksStates} linksLimit={linksLimit} />
        </Page>
    )
}

export default withReferenceDataState(LinksPage)
